import { createAuthClient } from "better-auth/vue"

export const authClient = createAuthClient({
    baseURL: process.env.VUE_APP_API_URL || "http://localhost:3000"
})
